export function Failed(responseBody) {
    return {
        success: false,
        error: {
            code: responseBody.errorCode,
            message: responseBody.message,
        },
    };
}
export function Success(key, value) {
    return {
        success: true,
        [key]: value,
    };
}
//# sourceMappingURL=request.js.map